import Select, { ActionMeta, MultiValue } from 'react-select';
import { ISelectOption } from './SearchSelectBox';
import SearchIcon from '../Icons/SearchIcon';

interface IMultiSelectSearchProps {
  placeholder: string;
  options: ISelectOption[];
  selectedOption?: string[];
  handleChange: (selected: string[]) => void;
  isSelectAll?: boolean;
}

const MultiSelectSearch = ({
  placeholder,
  options,
  selectedOption = [],
  handleChange,
  isSelectAll = true,
}: IMultiSelectSearchProps) => {
  const selectAllOption: ISelectOption = { value: 'all', label: 'Select All' };
  const handleSelect = (
    selected: MultiValue<ISelectOption>,
    actionMeta: ActionMeta<ISelectOption>,
  ) => {
    if (!selected || selected.length === 0) {
      handleChange([]);
      return;
    }
    if (actionMeta.removedValue) {
      if (actionMeta?.removedValue?.value == 'all') {
        handleChange([]);
        return;
      } else {
        const removeData = selected?.filter(
          (item) => item?.value != actionMeta?.removedValue?.value,
        );
        return handleChange(removeData.map((o) => o.value));
      }
    }
    const values = selected.map((opt) => opt.value);
    if (values.includes('all')) {
      if (selectedOption.length === options.length) {
        handleChange([]);
      } else {
        handleChange(options.map((opt) => opt.value));
      }
      return;
    }

    handleChange(values.filter((val) => val !== 'all'));
  };

  const isAllSelected = selectedOption.length === options.length;
  const selectedValues: ISelectOption[] = [
    ...(isAllSelected && isSelectAll ? [selectAllOption] : []),
    ...options.filter((opt) => selectedOption.includes(opt.value)),
  ];
  const selectOptions: ISelectOption[] = isSelectAll
    ? [selectAllOption, ...options]
    : options;
  return (
    <div className="position-relative">
      <span className="search-icon position-absolute ">
        <SearchIcon />
      </span>
      <Select
        value={selectedValues}
        isMulti
        classNames={{
          control: (state) => (state.isFocused ? 'w-100' : 'w-100'),
          option: (state) => (state.isSelected ? 'w-100' : 'w-100'),
          menu: () => 'w-100',
        }}
        options={selectOptions}
        onChange={handleSelect}
        placeholder={placeholder}
        isSearchable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        closeMenuOnSelect={false}
      />
    </div>
  );
};

export default MultiSelectSearch;
